import axios from "axios";
import { _DecryptService } from "../../service/EncryptDecryptService";

const isProduction = process.env.REACT_APP_IS_PRODUCTION === "true";
const API_BASE_URL = isProduction
  ? process.env.REACT_APP_API_ENDPOINT
  : process.env.REACT_APP_UAT_API_ENDPOINT;

const GetDashboardSummaryAPI = async () => {
  const endpoint = `${API_BASE_URL}/dashboard/summary`;
  const headers = {
    "Authorization": "Bearer " + _DecryptService(sessionStorage.getItem("token")),
    "Content-Type": "application/json",
  };
  const res = await axios.get(endpoint, { headers });
  return res.data;
};

export default GetDashboardSummaryAPI;
